import { PlusOutlined } from '@ant-design/icons';
import { useDebounceFn } from 'ahooks';
import { Form, Input } from 'antd';
import { RevxRadio } from 'components';
import { ExpertVersionnDeleteIcon } from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxInputNumber } from 'components/RevxInputNumber';
import { RevxRadioProps } from 'components/RevxRadio';
import { JobManualSvc } from 'domains/jobconfigDomain';
import { PartialSKU } from 'domains/skuDomain';
import { useEffect, useState } from 'react';
import { INPUT_NORMAL_MAX_LENGTH } from 'utils/constants';

import './SkuManualSvcs.less';

interface Props {
  sku: PartialSKU;
  onChange?: (value: JobManualSvc[] | undefined) => void;
}

export const SkuManualSvcs = (props: Props) => {
  const { sku, onChange } = props;
  const [svcForm] = Form.useForm();
  const [hideForm, setHideForm] = useState(false);
  const defaultFormValue = {
    name: '',
    description: '',
    cost: 0,
  };

  useEffect(() => {
    if (sku.jobManualSvcs?.length === 0 || !sku.jobManualSvcs) {
      svcForm.setFieldsValue({
        check: 'false',
        other: [],
      });
      setHideForm(true);
    } else {
      svcForm.setFieldsValue({
        check: 'true',
        other: sku.jobManualSvcs,
      });
      setHideForm(false);
    }
    // eslint-disable-next-line
  }, [sku.jobManualSvcs]);
  // useMount(() => {
  //   svcForm.setFieldsValue({
  //     check: 'true',
  //     other: [defaultFormValue]
  //   })
  // })
  const checkboxProps: RevxRadioProps = {
    inSideRevxLayoutProps: {
      justify: 'left',
      align: 'center',
      className: 'inSideRevxLayoutProps',
      style: {
        marginRight: '10px',
      },
    },
    options: [
      {
        value: 'true',
        children: (
          <>
            <span style={{ paddingLeft: '6px', marginRight: '30px' }}>Yes</span>
          </>
        ),
      },
      {
        value: 'false',
        children: (
          <>
            <span style={{ paddingLeft: '6px' }}>No</span>
          </>
        ),
      },
    ],
  };

  const { run: updateService, cancel: cancelUpdateService } = useDebounceFn(
    async () => {
      try {
        const data = await svcForm.validateFields();

        if (typeof onChange === 'function') {
          onChange(
            data?.other?.map((item: Partial<JobManualSvc>) => {
              item.type = item.name;
              return item;
            })
          );
        }
      } catch (e) {
        console.log(e);
      }
    },
    { wait: 100 }
  );

  return (
    <>
      <p className="expert-color-title">Add Service</p>
      <Form
        form={svcForm}
        className="skuManualSvcs-table"
        onValuesChange={async (value, allValue) => {
          cancelUpdateService();
          if (allValue.check === 'false') {
            setHideForm(true);
            svcForm.setFieldsValue({
              check: 'false',
              other: [],
            });
            // await dispatch.jobConfig.updateJobSpec({
            //   skuId: sku.skuId,
            //   manualSvcs: [],
            // });
          } else {
            setHideForm(false);
            if (allValue.other?.length === 0) {
              svcForm.setFieldsValue({
                check: 'true',
                other: [defaultFormValue],
              });
            }
            cancelUpdateService();
            updateService();
          }
        }}
      >
        <Form.Item name="check" noStyle>
          <RevxRadio {...checkboxProps} />
        </Form.Item>
        <RevxFlexLayout
          className="skuManualSvcs-table-header"
          hidden={hideForm}
        >
          <label className="expert-printing-name">Service Name</label>
          <label className="expert-printing-name">Service Description</label>
          <label className="expert-printing-name">Service cost</label>
        </RevxFlexLayout>
        <Form.List name="other">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field) => {
                return (
                  <RevxFlexLayout key={`${field.key}content`}>
                    <Form.Item
                      {...field}
                      key={`${field.key}name`}
                      name={[field.name, 'name']}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter name',
                        },
                      ]}
                      // fieldKey={[field.fieldKey, 'name']}
                    >
                      <Input maxLength={INPUT_NORMAL_MAX_LENGTH} />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      key={`${field.key}description`}
                      name={[field.name, 'description']}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter description',
                        },
                      ]}
                      // fieldKey={[field.fieldKey, 'description']}
                    >
                      <Input maxLength={INPUT_NORMAL_MAX_LENGTH} />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      key={`${field.key}cost`}
                      name={[field.name, 'cost']}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter cost',
                        },
                      ]}
                      // fieldKey={[field.fieldKey, 'cost']}
                    >
                      <RevxInputNumber
                        maxLength={INPUT_NORMAL_MAX_LENGTH}
                        prefix="$"
                        precision={2}
                      />
                    </Form.Item>
                    <div
                      onClick={async () => {
                        remove(field.name);
                        if (fields?.length <= 1) {
                          svcForm.setFieldsValue({
                            check: 'false',
                            other: [],
                          });
                          setHideForm(true);
                        }
                      }}
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      <ExpertVersionnDeleteIcon />
                    </div>
                  </RevxFlexLayout>
                );
              })}
              <RevxFlexLayout hidden={hideForm}>
                <div
                  className="skuManualSvcs-btn"
                  onClick={async () => {
                    add(defaultFormValue);
                  }}
                >
                  <PlusOutlined />
                  <span>Add line item</span>
                </div>
              </RevxFlexLayout>
            </>
          )}
        </Form.List>
      </Form>
    </>
  );
};
